module.exports = __webpack_public_path__ + "static/media/social-facebook.ff8790f7.svg";